import Layouts from "./layouts/index.js";
const { // plop_marker:segment_index_import_layout
FullBackgroundHero } = Layouts;
export default {
    // plop_marker:segment_index_add_layout
    FullBackgroundHeroComponent: {
        type: "FullBackgroundHeroComponent",
        title: "Full Background",
        imgSrc: "/static/img/segments/layouts/full-background-hero.png",
        config: FullBackgroundHero.FullBackgroundHeroConfig,
        component: FullBackgroundHero.FullBackgroundHeroComponent
    }
};
